<template>
  <div class="myinfo">
    <div class="tips">
      <p>
        <i class="iconfont icon-shuoming"></i>
        如果您的账号还未绑定手机号，<a
          style="color: #1890ff; font-size: 16px"
          @click="gotoBindTel"
          >可以点此绑定</a
        >
      </p>
    </div>
    <div class="form-horizontal myform">
      <div class="input-group">
        <span class="input-group-addon">请输入您的姓名</span>
        <input
          type="text"
          class="form-control"
          placeholder="请输入姓名"
          aria-describedby="basic-addon1"
          v-model="name"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon">请输入手机号</span>
        <input
          type="text"
          class="form-control"
          placeholder="请输入手机号"
          aria-describedby="basic-addon1"
          v-model="phone"
        />
      </div>
      <div class="input-group">
        <span class="input-group-addon">请输入图形验证码</span>
        <input
          type="text"
          class="form-control"
          placeholder="请输入图形验证码"
          aria-describedby="basic-addon1"
          v-model="captcha"
        />
        <img :src="imageCode" @click="getRandomImage" />
      </div>

      <div class="form-group row">
        <label class="input-group-addon">手机验证码</label>
        <div class="col-md-4">
          <input
            class="form-control border"
            v-model="phoneVerifyCode"
            placeholder="请输入手机验证码"
          />
        </div>
        <div class="col-md-4">
          <button
            type="button"
            class="btn-default form-control sub"
            @click="getSmsVerifyCode"
            :disabled="smsDisabled"
          >
            {{ smsMessage }}
          </button>
        </div>
      </div>

      <div class="input-group">
        <span class="input-group-addon">新密码</span>

        <input
          type="password"
          autocomplete="new-password"
          class="form-control"
          placeholder="请输入新密码"
          aria-describedby="basic-addon1"
          v-model="npwd"
        />
      </div>

      <div class="input-group">
        <span class="input-group-addon">重复密码</span>

        <input
          type="password"
          class="form-control"
          autocomplete="new-password"
          placeholder="请再次输入新密码"
          aria-describedby="basic-addon1"
          v-model="npwd_again"
        />
      </div>

      <div class="tips">
        提示： 新密码至少8位，不超过20位 需由数字、大小写字母和特殊符号组成
      </div>

      <div class="form-group row">
        <div class="col-md-12">
          <button
            type="submit"
            @click="submit"
            class="btn btn-default form-control sub"
          >
            提交
          </button>
          <div style="text-align: right; margin: 10px; color: #1890ff">
            <span style="cursor: pointer" @click="gotoLogin">返回登录</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <a-modal
      :visible="showFlag"
      title=""
      :maskClosable="false"
      :closable="false"
      :footer="null"
      :width="300"
    >
      <div style="margin: 20px 10px">
        <span
          >我们已将新密码通过短信的方式发送到您的手机号{{
            phone.substr(0, 3) + "****" + phone.substr(7)
          }}，请注意查收。</span
        ><br />
        <span>点击确定按钮跳转到登录页面</span>
      </div>
      <a-button type="primary" style="width: 100%" @click="gotoLogin"
        >确定</a-button
      >
    </a-modal> -->
    <!-- 绑定手机号弹框 -->
    <!-- <a-modal
      :visible="showBindTel"
      title=""
      :maskClosable="false"
      :closable="false"
      :footer="null"
    >
      <BindTel :bind-tel-random-number="bindTelRandomNumber" />
    </a-modal> -->
    <!--    <BindTel :visible="showBindTel"/>-->
  </div>
</template>

<script>
import BindTel from "./BindTel.vue";
import JsEncrypt from "jsencrypt";
export default {
  name: "ViewState",
  components: { BindTel },
  data: function () {
    return {
      randomCode: null,
      imageCode: `/static/images/checkcode.png`,
      captcha: "",
      phone: "",
      sms: "",
      name: null,
      showFlag: false,
      showBindTel: false,
      bindTelRandomNumber: null,
      phoneVerifyCode: "",
      smsDisabled: false,
      smsMessage: `获取短信验证码`,
      npwd: "", // 新密码
      npwd_again: "", // 确认新密码
      publicKey: null, // 用于加密密码的key
      uuid: null, // 用于向后台确认加密key的id
    };
  },
  mounted() {
    this.name = null;
    this.captcha = null;
    this.phone = null;
    const number = parseInt(Math.random(1) * Math.pow(10, 10));
    console.log(number);
    this.randomCode = number;
    this.getRandomImage(); //获取图形验证码
    this.axios.get(`/sys/login/token`).then((res) => {
      this.publicKey = res.result.publicKey;
      this.uuid = res.result.uuid;
    });
  },
  methods: {
    getRandomImage() {
      this.axios.get(`/sys/randomImage/${this.randomCode}`).then((res) => {
        console.log(res);
        this.imageCode = res.result;
      });
    },
    gotoLogin() {
      this.showFlag = false;
      this.$router.push("login");
    },
    gotoBindTel() {
      this.$router.push("userbind");
    },
    // 获取短信验证码
    getSmsVerifyCode() {
      if (!this.name) {
        this.$message.warning("请输入姓名!");
        return;
      }
      const myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.phone) {
        this.$message.warning("请输入手机号!");
        return false;
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (!this.captcha) {
        this.$message.warning("请输入图形验证码");
        return;
      }
      this.axios
        .get(`/biz/user/resetPwd/sms`, {
          params: {
            stuName: this.name,
            captcha: this.captcha,
            checkKey: this.randomCode,
            mobile: this.phone,
            method: "1",
          },
        })
        .then((res) => {
          if (res.success) {
            this.$message.success("发送成功");
            this.countdown(300);
          } else {
            this.getRandomImage();
          }
        })
        .catch(() => {
          this.getRandomImage();
        });
    },
    submit() {
      if (!this.name) {
        this.$message.warning("请输入姓名!");
        return;
      }
      const myregPhone = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/;
      if (!this.phone) {
        this.$message.warning("请输入手机号!");
        return false;
      } else if (!myregPhone.test(this.phone)) {
        this.$message.warning("手机号格式不正确");
        return false;
      }
      if (!this.phoneVerifyCode) {
        this.$message.warning("请输入手机验证码!");
        return;
      }
      if (!this.npwd) {
        this.$message.warning("请输入新密码!");
        return;
      }
      var myreg =
        /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9])).{8,20}$/;
      if (!myreg.test(this.npwd)) {
        this.$message.warning(
          "新密码至少8位，不超过20位需由数字、大小写字母和特殊符号组成"
        );
        return;
      }
      if (!this.npwd_again) {
        this.$message.warning("请再次输入新密码!");
        return;
      }
      if (this.npwd_again !== this.npwd) {
        this.$message.warning("两次输入的密码不一致，请重新输入！");
        return;
      }
      const jse = new JsEncrypt();
      jse.setPublicKey(this.publicKey);
      const params = {
        checkKey: this.randomCode,
        stuName: this.name,
        password: jse.encrypt(this.npwd),
        mobile: this.phone,
        uuid: this.uuid,
        captcha: this.phoneVerifyCode,
        method: "1",
      };
      this.axios
        .post(`/biz/user/updatePassword`, params)
        .then((res) => {
          if (res.success) {
            this.$message.success("操作成功, 即将跳转登录页面");
            setTimeout(() => {
              this.gotoLogin();
            }, 1000);
          }
        })
        .catch(() => {
          this.randomCode = parseInt(Math.random(1) * Math.pow(10, 10));
          this.getRandomImage();
        });
    },

    // 倒计时
    countdown(index) {
      let countdownData = index;
      this.smsDisabled = true;

      if (this.timer) {
        clearInterval(this.timer);
      }

      this.timer = setInterval(() => {
        if (countdownData >= 0) {
          this.smsMessage = `${countdownData}秒后重试`;
          countdownData--;
        } else {
          this.smsMessage = `获取短信验证码`;
          this.smsDisabled = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.myinfo {
  padding: 20px;
  margin-top: 10px;
}

.myform {
  width: 540px;
  margin: 0 auto;
  background: none;
  color: #999;

  .input-group {
    margin-bottom: 20px;
  }

  .input-group-addon {
    display: inline-block;
    width: 170px;
    text-align: center;
    line-height: 33px;
  }

  .sub {
    background: $bgColor;
    color: #fff;
  }
}

.icon-shuoming {
  color: $bgColor;
}

.tips {
  font-size:15px;
  line-height: 18px;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/findpwd/components/ViewStatus.vue